import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';
import { ErrorMessage } from '../validation/validationError';
import { adminPaperPatternAddFormValidation } from '../validation/Validation';
import { ZodError } from 'zod';

const PaperPattern = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const initialExamPatterState = {
        examPatternMasterId: "",
        subjectMasterId: "",
        questionTypeMasterId: "",
        questionPattern: []
    }

    const [paperPatternData, setPaperPatternData] = useState(initialExamPatterState)
    const [error, setError] = useState([]);

    const [examPatternList, setExamPatternList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [questionTypeList, setQuestionTypeList] = useState([]);

    const [paperPatternList, setPaperPatternList] = useState([]);

    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);

    // const [examPatternSort, setExamPatternSort] = useState(null);
    // const [positiveQuestionMarkSort, setPositiveQuestionMarkSort] = useState(null);
    // const [negativeQuestionMarkSort, setNegativeQuestionMarkSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["exam_pattern_name", "perquestion_marks", "pernegetive_question_marks"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getPaperPatternList();
    }, []);

    useEffect(() => {
        getExamPatternList();
        getSubject();
        getQuestionTypeList();
    }, []);

    const getApiUrl = () => {
        let apiUrl = `/get-paper-pattern?`;
        if (paperPatternData.examPatternMasterId) {
            apiUrl += `examPatternMasterId=${paperPatternData.examPatternMasterId}`
        }

        return apiUrl;
    }

    const getPaperPatternList = async () => {
        try {
            console.log(getApiUrl());
            const response = await authorizedAxios.get(getApiUrl());
            console.log("paper pattern list");
            setPaperPatternList(response.data.result);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }


    const getExamPatternList = async () => {
        try {
            const apiUrl = `/exam-patterns`;
            const response = await authorizedAxiosCommon.get(apiUrl);
            setExamPatternList(response.data.data);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getSubject = async () => {
        const apiUrl = `/get-subject-master`;
        try {
            const response = await authorizedAxios.get(apiUrl);
            setSubjectList(response.data.result);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getQuestionTypeList = async () => {
        try {
            const apiUrl = `/get-question-type-master`;
            const response = await authorizedAxios.get(apiUrl);
            setQuestionTypeList(response.data.result);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }


    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        setPaperPatternList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(paperPatternList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(paperPatternList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > paperPatternList.length) {
            endIndex = paperPatternList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(paperPatternList.slice(startIndex, endIndex));
    }, [paperPatternList, currPage, itemsPerPage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPaperPatternData(prevData => ({
            ...prevData,
            [name]: value.toString()
        }));

        if (value.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleAddQuestionPattern = async () => {
        try {
            await adminPaperPatternAddFormValidation.parseAsync(paperPatternData);
            setError([]);
            const newPattern = {
                subjectMasterId: paperPatternData.subjectMasterId,
                questionTypeMasterId: paperPatternData.questionTypeMasterId,
                positiveMarks: "",
                negativeMarks: "",
                totalQuestion: "",
            }

            setPaperPatternData(prevData => ({
                ...prevData,
                subjectMasterId: "",
                questionTypeMasterId: "",
                questionPattern: [...prevData.questionPattern, newPattern],
            }));
        } catch (error) {
            if (error instanceof ZodError) {
                setError(error.errors);
                console.log(error.errors);
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const handleRowChange = (index, name, value) => {
        const filteredValue = value.replace(/[^0-9]/g, '')
        const updatedPatterns = [...paperPatternData.questionPattern];
        updatedPatterns[index][name] = filteredValue;
        setPaperPatternData(prevData => ({
            ...prevData,
            questionPattern: updatedPatterns,
        }));
    }

    const handleDeleteRow = (patternIndex) => {
        const updatedQuestinPattern = paperPatternData.questionPattern.filter((_, index) => index !== patternIndex);
        setPaperPatternData(prevData => ({
            ...prevData,
            questionPattern: updatedQuestinPattern
        }));
    }

    const addPattern = async () => {
        try {
            setLoading(true);
            const apiUrl = `/add-paper-pattern`;
            const response = await authorizedAxios.post(apiUrl, paperPatternData);
            console.log("Before");
            await getPaperPatternList();
            setPaperPatternData(initialExamPatterState)

            setSaveId(response?.data?.result?.created[0]?.id || response?.data?.result?.duplicates[0]?.id);

            // setExamPatternSort(null);
            // setPositiveQuestionMarkSort(null);
            // setNegativeQuestionMarkSort(null);

            Swal.fire({ text: response.data.message });
        } catch (error) {
            const errorMsg = error?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false);
        }
    }

    const deletePaper = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-paper-pattern?id=${id}`;
                const response = await authorizedAxios.delete(apiUrl);
                await getPaperPatternList();
                const page = deleteItem(currPage, itemsPerPage, examPatternList.length);
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updatePaper = async () => {
        try {
            const apiUrl = `/edit-paper-pattern?id=${editId}`;
            setLoading(true);
            const updatedPattern = {
                examPatternMasterId: paperPatternData.examPatternMasterId,
                subjectMasterId: paperPatternData.subjectMasterId,
                questionTypeMasterId: paperPatternData.questionTypeMasterId,
                positiveMarks: paperPatternData.questionPattern[0].positiveMarks,
                negativeMarks: paperPatternData.questionPattern[0].negativeMarks,
                totalQuestion: paperPatternData.questionPattern[0].totalQuestion
            }

            const response = await authorizedAxios.put(apiUrl, updatedPattern);
            await getPaperPatternList();
            setSaveId(response.data.result.id);
            setPaperPatternData(initialExamPatterState)
            setEditId(null);
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    // useEffect(() => {
    //     if (examPatternSort == true || examPatternSort == false) {
    //         setPositiveQuestionMarkSort(null);
    //         setNegativeQuestionMarkSort(null);
    //     }
    // }, [examPatternSort])

    // useEffect(() => {
    //     if (positiveQuestionMarkSort == true || positiveQuestionMarkSort == false) {
    //         setExamPatternSort(null);
    //         setNegativeQuestionMarkSort(null);
    //     }
    // }, [positiveQuestionMarkSort])

    // useEffect(() => {
    //     if (negativeQuestionMarkSort == true || negativeQuestionMarkSort == false) {
    //         setExamPatternSort(null);
    //         setPositiveQuestionMarkSort(null);
    //     }
    // }, [negativeQuestionMarkSort])

    console.log({ paperPatternData })
    console.log("Errors: ", error)

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Paper Pattern</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-table"></i>Paper Pattern</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-4">
                                                    <label for="examPatternMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Exam Pattern :</label>
                                                    <select class="form-select" aria-label="Default select example" name='examPatternMasterId' onChange={handleInputChange} value={paperPatternData.examPatternMasterId}>
                                                        <option selected value={''} disabled>Select Exam Pattern</option>
                                                        {
                                                            examPatternList?.map((pattern) => {
                                                                return <option key={pattern.id} value={pattern.id}>{pattern.exam_pattern_name}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="examPatternMasterId" />
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="subjectMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleInputChange} value={paperPatternData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((subject) => {
                                                                return <option key={subject.id} value={subject.id}>{subject.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="subjectMasterId" />
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="questionTypeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Question Type :</label>
                                                    <select class="form-select" aria-label="Default select example" name='questionTypeMasterId' onChange={handleInputChange} value={paperPatternData.questionTypeMasterId}>
                                                        <option selected value={''} disabled>Select Question Type</option>
                                                        {
                                                            questionTypeList?.map((question) => {
                                                                return <option key={question.id} value={question.id}>{question.questionTypeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="questionTypeMasterId" />
                                                </div>

                                                {!editId && <div className='col-md-2 mt-3'>
                                                    <button type='button' className='btn btn-success' onClick={handleAddQuestionPattern}>+ Add</button>
                                                </div>}

                                            </div>

                                            {(paperPatternData.questionPattern.length > 0 || editId) && (
                                                <div className='col-md-12 mt-3 m-auto'>
                                                    <table className='table table-bordered'>
                                                        <thead className='custom-thead'>
                                                            <tr>
                                                                {!editId && <th>Subject</th>}
                                                                {!editId && <th>Question Type</th>}
                                                                <th>Positive Marks</th>
                                                                <th>Negative Marks</th>
                                                                <th>Total Question</th>
                                                                {!editId && <th>Action</th>}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {paperPatternData.questionPattern.map((row, index) => (
                                                                <tr key={index}>
                                                                    {!editId && <td>
                                                                        {subjectList.find(s => s.id == row.subjectMasterId)?.subjectName}
                                                                    </td>}
                                                                    {!editId && <td>
                                                                        {questionTypeList.find(q => q.id == row.questionTypeMasterId)?.questionTypeName}
                                                                    </td>}
                                                                    <td>
                                                                        <input type='text' className='form-control' value={row.positiveMarks} onChange={(e) => handleRowChange(index, "positiveMarks", e.target.value)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type='text' className='form-control' value={row.negativeMarks} onChange={(e) => handleRowChange(index, "negativeMarks", e.target.value)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type='text' className='form-control' value={row.totalQuestion} onChange={(e) => handleRowChange(index, "totalQuestion", e.target.value)} />
                                                                    </td>
                                                                    <td>
                                                                        <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => handleDeleteRow(index)}> <i class="fa-light fa-trash-can"></i></button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addPattern}>Save</button>}
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setEditId(null); setPaperPatternData(initialExamPatterState); setError([]) }}>Reset</button>
                                                        {editId && (<button className="btn btn-success approve_icon" type="button" onClick={updatePaper} disabled={!editId}>Update</button>)}
                                                    </div>
                                                </div>
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Exam Pattern
                                                                            {/* <SortIcon sortState={examPatternSort} setSortState={setExamPatternSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"exam_pattern_name"} /> */}
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            {/* <SortIcon sortState={positiveQuestionMarkSort} setSortState={setPositiveQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"perquestion_marks"} /> */}
                                                                        </th>
                                                                        <th scope="col">
                                                                            Question Type
                                                                            {/* <SortIcon sortState={negativeQuestionMarkSort} setSortState={setNegativeQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"pernegetive_question_marks"} /> */}
                                                                        </th>
                                                                        <th scope="col">
                                                                            Positive Marks
                                                                            {/* <SortIcon sortState={negativeQuestionMarkSort} setSortState={setNegativeQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"pernegetive_question_marks"} /> */}
                                                                        </th>
                                                                        <th scope="col">
                                                                            Negative Marks
                                                                            {/* <SortIcon sortState={negativeQuestionMarkSort} setSortState={setNegativeQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"pernegetive_question_marks"} /> */}
                                                                        </th>
                                                                        <th scope="col">
                                                                            Questions
                                                                            {/* <SortIcon sortState={negativeQuestionMarkSort} setSortState={setNegativeQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"pernegetive_question_marks"} /> */}
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((paper, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{paper.examPatternDetails.exam_pattern_name}</td>
                                                                                        <td>{paper.subjectMasterDetails.subjectName}</td>
                                                                                        <td>{paper.questionTypeMasterDetails.questionTypeName}</td>
                                                                                        <td>{paper.positiveMarks}</td>
                                                                                        <td>{paper.negativeMarks}</td>
                                                                                        <td>{paper.totalQuestion}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setPaperPatternData({
                                                                                                    examPatternMasterId: paper.examPatternDetails.id,
                                                                                                    subjectMasterId: paper.subjectMasterDetails.id,
                                                                                                    questionTypeMasterId: paper.questionTypeMasterDetails.id,
                                                                                                    // positiveMarks: paper.positiveMarks,
                                                                                                    // negativeMarks: paper.negativeMarks,
                                                                                                    // totalQuestion: paper.totalQuestion,
                                                                                                    questionPattern: [
                                                                                                        {
                                                                                                            // subjectMasterId: paper.subjectMasterDetails.id,
                                                                                                            // questionTypeMasterId: paper.questionTypeMasterDetails.id,
                                                                                                            positiveMarks: paper.positiveMarks,
                                                                                                            negativeMarks: paper.negativeMarks,
                                                                                                            totalQuestion: paper.totalQuestion
                                                                                                        }
                                                                                                    ]
                                                                                                });
                                                                                                setEditId(paper.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === paper.id} onClick={() => deletePaper(paper.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Paper Pattern Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={paperPatternList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default PaperPattern;